import React, { useState, useEffect } from "react";
import { Sidebar } from "./Sidebar";
import Header from "./Header";

const MainLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => window.innerWidth < 1024
  );

  useEffect(() => {
    let prevWidth = window.innerWidth;
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      // Auto-collapse when crossing below the tablet/desktop threshold
      if (prevWidth >= 1024 && currentWidth < 1024) {
        setSidebarCollapsed(true);
      }
      prevWidth = currentWidth;
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`main-layout ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar isCollapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      <Header sidebarCollapsed={sidebarCollapsed} />

      <main className="main-content bg-light min-vh-100">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
